import SlideStandards from './SlideStandards';

export default SlideStandards;
